import { FileReference } from "../files";
import { Id } from "./id";
import { SortOrder } from "./project-section";
import { z } from "zod";
export const ForgeProjectArtifact = z.object({
    id: Id,
    projectId: z.string(),
    iterationId: z.string().nullish(),
    title: z.string(),
    previewUrl: z.string().nullish(),
    sortOrder: SortOrder.default(0),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    createdByUserId: z.string(),
    sectionId: Id.optional(),
    threadId: z.string().optional(),
    thumbnail: FileReference.optional(),
    // Default value here is important for backward compatibility for parsing artifacts
    // from project rooms!
    isArchived: z.boolean().default(false),
});
